import { Component, OnInit, output, input, inject } from '@angular/core';
import { FormControl, NgControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { AuthenticationToken } from '@ap/browser-authenticator';
import { ApContentService, ApContentPipe } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';
import { markFormControlAsDone } from '@ap/form';
import { ApRadioGroupComponent, ApRadioButtonComponent } from '@ap/radio';
import { ApButtonComponent } from '@ap/button';

import content from './selector.content.json';
import { ApBrowserSelectorSkeletonComponent } from './selector-skeleton/browser-selector-skeleton.component';

@Component({
    selector: 'ap-browser-selector',
    templateUrl: './selector.component.html',
    styleUrls: ['./selector.component.scss'],
    imports: [
        ReactiveFormsModule,
        ApRadioGroupComponent,
        ApRadioButtonComponent,
        ApContentPipe,
        ApButtonComponent,
        ApBrowserSelectorSkeletonComponent
    ]
})
export class ApBrowserSelectorComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    /**
     * Is signing implicit?
     * The header for selecting from a multi-user browser registration will be hidden when set to `true`
     * Defaults to false
     */
    public readonly implicitSigning = input(false);

    /**
     * Available authentication tokens
     */
    public readonly tokens = input<AuthenticationToken[]>(undefined);

    /**
     * Emits when a token is selected
     */
    public tokenSelected = output<string>();

    public tokenControl = new FormControl<string>(null, Validators.required);
    public errors: ErrorMessages;

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.errors = {
            required: this.contentService.get('browser.selector.error.required')
        };
    }

    protected selectToken(): void {
        markFormControlAsDone(this.tokenControl);
        if (this.tokenControl.valid) {
            this.tokenSelected.emit(this.tokenControl.value);
        }
    }

    protected get ngTokenControl(): NgControl {
        return this.tokenControl as any as NgControl;
    }

    public encode(name: string): string {
        return name.replace('<', '&lt;');
    }
}
